import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { FeatureSelectionOptionsContext } from "./FeatureSelectionOptionsContext";
import FeatureManagementSettings from "../pages/FeatureManagementSettings";
import { otherConfigOptionsAttributes } from "../../salescodeStudio/mandatoryConfigs/configSetupScreen/widget/configBottomBar";
import { fetchAndSetUiConfigOptions, getAllFeaturesForSelectedRole, getMetaDataConfig, setAppAndRoleOptions } from "../../../services/uiConfigService";
import { AppOptionType, OptionType } from "../../manageHomepage/ManageHomePageTypes";
interface Props {
  children?: React.ReactNode; 
}

const FeatureSelectionProviderWrapper = ({ children }: Props) => {
  const [uiConfigOptionsProp, setUiConfigOptionsProp] = useState<otherConfigOptionsAttributes[]>([]);
  const clientConfigRef = useRef<any>(null);
  const savedAppType = useSelector((state: any) => state.appTypeState.appType);
  const allConfigRef = useRef<otherConfigOptionsAttributes[]>([]);
  const savedRole = useSelector((state: any) => state.roleState.role) ?? savedAppType?.designations?.[0];
  const [featureChangeList,setFeatureChangeList]=useState<string[]>([])
  const [onSaved,setOnSaved]=useState<boolean>(false);
  const [appTypeOptions, setAppTypeOptions] = useState<AppOptionType[]>([]);
  const [roleOptions, setRoleOptions] = useState<OptionType[]>([]);
  const setUiConfigOptionsAccToAppType = async (savedAppType: AppOptionType,clientConfigRef:any) => {
    if (!savedAppType?.id) return;

    const allConfigs = allConfigRef.current ?? [];

    const filteredConfigs = getAllFeaturesForSelectedRole(savedRole,allConfigs,clientConfigRef,savedAppType)

    setUiConfigOptionsProp(filteredConfigs);
  };
  const init = async () => {
    const clientConfig = await getMetaDataConfig("clientconfig");
    clientConfigRef.current = clientConfig??[];
     const resp = setAppAndRoleOptions({
        setAppTypeOptions: setAppTypeOptions,
        setRoleOptions: setRoleOptions,
        clientConfig: clientConfig,
        savedRole: savedRole
    });
    const allConfigs = await fetchAndSetUiConfigOptions();
    allConfigRef.current = allConfigs;
    setUiConfigOptionsAccToAppType(resp.appType ?? savedAppType,clientConfigRef);
  }
  useEffect(() => {
    if(clientConfigRef.current)
    setUiConfigOptionsAccToAppType(savedAppType,clientConfigRef);
    setFeatureChangeList([])
  }, [savedAppType?.id,savedRole?.id]);
  useEffect(()=>{
    // debugger;
    init();
  },[onSaved])
  return (
    <FeatureSelectionOptionsContext.Provider
      value={{ uiConfigOptionsProp, setUiConfigOptionsProp,featureChangeList,setFeatureChangeList,setOnSaved,onSaved}}
    >
      {children ? (
        children
      ) : (
        <FeatureManagementSettings
          uiConfigOptionsProp={uiConfigOptionsProp}
          setUiConfigOptionsProp={setUiConfigOptionsProp}
        />
      )}
    </FeatureSelectionOptionsContext.Provider>
  );
};

export default FeatureSelectionProviderWrapper;
